import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=04608c16"
import script from "./PersonalInformation.vue?vue&type=script&lang=ts"
export * from "./PersonalInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports